var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("figure", { staticClass: "analog-clock" }, [
    _c(
      "figcaption",
      { staticClass: "analog-clock__face" },
      _vm._l(60, function(n) {
        return _c("span", {
          key: n,
          staticClass: "analog-clock__notch",
          class: { "-long": !(n % 5) },
          style: { transform: "rotate(" + n * 6 + "deg)" }
        })
      }),
      0
    ),
    _vm._v(" "),
    _c("span", {
      staticClass: "analog-clock__hand -seconds",
      style: _vm.seconds
    }),
    _vm._v(" "),
    _c("span", {
      staticClass: "analog-clock__hand -minutes",
      style: _vm.minutes
    }),
    _vm._v(" "),
    _c("span", { staticClass: "analog-clock__hand -hours", style: _vm.hours })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }